import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';
import Modal from 'ui-library/modals/Modal';

const BASIC_HELP_MODAL_KEY = 'BASIC_HELP_MODAL_KEY';

interface BasicHelpModalProps {
  title: string;
  onRequestClose: () => void;
  children: React.ReactNode;
}

class BasicHelpModal extends React.Component<BasicHelpModalProps> {
  static open({title, msg}: {title: string; msg: React.ReactNode}): void {
    LegacyModalContainer.open(
      BASIC_HELP_MODAL_KEY,
      <BasicHelpModal
        title={title}
        onRequestClose={function () {
          LegacyModalContainer.close(BASIC_HELP_MODAL_KEY);
        }}
      >
        {msg}
      </BasicHelpModal>
    );
  }

  override render(): JSX.Element {
    return (
      <Modal
        enableRedesign={true}
        title={this.props.title}
        onRequestClose={this.props.onRequestClose}
        buttons={[{text: 'OK', cancel: true, style: ButtonStyle.PRIMARY}]}
      >
        {this.props.children}
      </Modal>
    );
  }
}

export function showBasicHelpModal(
  e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
  title: string,
  msg: React.ReactNode
): void {
  e.preventDefault();
  BasicHelpModal.open({title, msg});
}

function showPublicHelp(e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>): void {
  showBasicHelpModal(
    e,
    'Folder Privacy',
    <div>
      <p>
        {'Files in '}
        <strong>private</strong>
        {` projects are not viewable or editable by anyone unless \
  you add them as collaborators in the project's settings.`}
      </p>
      <p>
        {'Files in '}
        <strong>public</strong>
        {` projects are viewable by anyone, including users that are \
  not signed into Benchling. They are only editable by users you add as collaborators.`}
      </p>
    </div>
  );
}

function showGoldenGateOverhangHelp(e: React.MouseEvent<HTMLElement>): void {
  showBasicHelpModal(
    e,
    'Golden Gate Overhangs',
    <div>
      <p>
        For all overhangs that can interact during assembly, we check if any of the following problems are
        present:
      </p>
      <ul>
        <li>Are any overhangs exactly the same?</li>
        <li>
          {'Do any overhangs share three consecutive bases that are the same (e.g. '}
          <b>CAG</b>T and A<b>CAG</b>
          )?
        </li>
        <li>
          Do any overhangs differ in only one base pair (e.g. T<b>A</b>
          AG and T<b>T</b>
          AG)?
        </li>
      </ul>
      <p>We additionally check that each overhang doesn't have GC content of 0% or 100%.</p>
      <p>
        When generating overhangs for fragments linearized by PCR, we attempt to find overhangs that allow the
        assembly to pass all of the above rules, although successful assemblies can occur even with overhangs
        differing by only one base pair.
      </p>
    </div>
  );
}

export {showPublicHelp, showGoldenGateOverhangHelp};
